export default "__VITE_ASSET__D0Yv6yXw__"